import {
  Intercom, onShow, onHide,
  boot,
} from '@intercom/messenger-js-sdk';

export default function bootIntercom(user) {
  if (!process.env.VUE_APP_INTERCOM_APP_ID) return;
  log('Booting Intercom with user:', user);
  Intercom({
    app_id: process.env.VUE_APP_INTERCOM_APP_ID,
    ...user,
  });
  boot({
    hide_default_launcher: true,
  });

  onShow(() => {
    document.dispatchEvent(new CustomEvent('intercom-opened'));
  });

  onHide(() => {
    document.dispatchEvent(new CustomEvent('intercom-closed'));
  });
}
